const defaultLocale = 'zh-HK';

const getLocale = (lang, country) =>
  `${lang.toLowerCase()}-${country.toUpperCase()}`;

export const getPrivacyUrl = (lang, country) => {
  const locale = getLocale(lang, country);
  const urlMap = {
    'zh-HK': 'https://spaceship.hk/privacy/',
    'zh-TW': 'https://www.spaceshipapp.com/zh-tw/privacy/',
    'en-HK': 'https://spaceship.hk/en/privacy/',
    'en-TW': 'https://www.spaceshipapp.com/zh-tw/privacy/' // fallback to zh-TW
  };

  return urlMap[locale] || urlMap[defaultLocale];
};

export const getTermsUrl = (lang, country) => {
  const locale = getLocale(lang, country);
  const urlMap = {
    'zh-HK': 'https://spaceship.hk/terms/',
    'zh-TW': 'https://www.spaceshipapp.com/zh-tw/terms/',
    'en-HK': 'https://spaceship.hk/en/terms/',
    'en-TW': 'https://www.spaceshipapp.com/zh-tw/terms/' // fallback to zh-TW
  };

  return urlMap[locale] || urlMap[defaultLocale];
};

export const getProhibitedItemsUrl = (lang, country) => {
  const locale = getLocale(lang, country);
  const urlMap = {
    'zh-HK': 'https://support.spaceshipapp.com/zh-hk/限制寄運及禁運物品名單/',
    'zh-TW': 'https://www.spaceshipapp.com/zh-tw/shipping-restriction/',
    'en-HK':
      'https://support.spaceshipapp.com/en/list-of-restricted-and-prohibited-item',
    'en-TW': 'https://www.spaceshipapp.com/zh-tw/shipping-restriction/' // fallback to zh-TW
  };

  return urlMap[locale] || urlMap[defaultLocale];
};

export const openPopupWindow = (url, title = 'Spaceship') => {
  const width = 800;
  const height = 600;
  const posX = 100;
  const posY = 100;

  return window.open(
    url,
    title,
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${posY}, left=${posX}`
  );
};
